<template>
  <v-dialog @keydown.esc="isOpen=false" v-model="isOpen" persistent max-width="400px">
    <v-card>
      <v-card-title>
        <span class="headline">{{ item.name }}</span>
      </v-card-title>
      <v-card-text>
        <span>La receta (Wansoft) seleccionada transferira los datos a la receta actual y posteriormente sera borrada.</span>
        <v-form ref="matchRecipeWantsoft" v-model="form.valid">
          <v-container grid-list-xl>
            <v-layout wrap>
              <v-flex xs12 md12>
                <v-autocomplete
                  v-model="form.data.recipe"
                  :items="recipes.items"
                  loading="Cargando recetas"
                  :search-input.sync="recipes.search"
                  outlined
                  clearable
                  rounded
                  color="primary"
                  hide-no-data
                  hide-selected
                  item-text="name"
                  item-value="_id"
                  label="Buscar receta"
                  placeholder="Nombre de receta"
                >
                  <template v-slot:item="{ item }">
                    <template>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ item.name }}
                        </v-list-item-title>
                        <v-list-item-subtitle v-if="item.internalId">
                          {{ item.internalId }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </template>
                </v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="error"
          class="mr-4"
          rounded
          small
          depressed
          @click="closeDialog('close')">
          Cerrar
        </v-btn>
        <v-btn
          color="primary"
          class="mr-4"
          rounded
          small
          depressed
          :disabled="!form.data.recipe"
          @click="submit">
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-dialog>
</template>

<script>
import { debounce } from 'lodash'

export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    btn: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      overlay: false,
      isOpen: false,
      form: {
        valid: false,
        data: {
          recipe: ''
        }
      },
      recipes: {
        search: '',
        items: []
      }
    }
  },
  computed: {
    restaurantId: function () {
      return this.$store.state.currentRestaurant.data._id
    },
    area: function () {
      return this.$store.state.area.id
    }
  },
  watch: {
    isOpen (val) {
      if (val) {
        this.resetRecipeForm()
      }
    },
    'recipes.search': debounce(async function (val) {
      if (val && val.length >= 3) {
        const params = {
          excludeRecipe: this.item._id,
          name: `/${val}/i`,
          area: this.area,
          restaurant: this.restaurantId,
          createdBySalePoint: false
        }
        try {
          const res = await this.$api.get(`/v1/recipes`, params)
          this.recipes.items = res.data
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
      }
    }, 600)
  },
  methods: {
    submit: async function () {
      this.$refs.matchRecipeWantsoft.validate()

      if (this.form.valid) {
        this.overlay = true
        try {
          await this.$api.post(`/v1/recipes/${this.item._id}/match`, { wRecipe: this.form.data.recipe, area: this.area })
          this.$toasted.show('Se ha llevado acabo con éxito.', { duration: 3000 })
          this.resetRecipeForm()
          this.closeDialog('submit')
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.overlay = false
      }
    },
    resetRecipeForm () {
      this.form.data = {
        recipe: ''
      }
    },
    closeDialog (event) {
      this.isOpen = false
      this.$emit(event)
    },
    open () {
      this.isOpen = true
    }
  }
}
</script>
